<!-- start: splash screen -->
<div #splashScreen id="splash-screen">
  <img [src]="brandingMedia.SPLASH_LOADER" alt="Loading..." height="92px" />
</div>
<!-- end: splash screen -->